<template>
  <div id="home" data-bs-theme="" class=" ">
    <header class="header">
      <div class="topHeader">
        <div class="customContainer">
          <div class="topHeader__inner">
            <p v-if="nonTopPage" class="backButton topHeader__backButton" ref="backButton">
              <a class="backButton__a" @click="backAction">{{ word_chg('予約する') }}戻る</a></p>

            <h1 class="titleHeader__title" v-if="nonTopPage">{{ pageHeaderTitle }}</h1>
            <h1 class="topHeader__logo" v-else>
              <a href="#" @click="routerLinkAction('/')"><img class="topHeader__logoImage" src="@/assets/img/main/header_img_01.png" alt=""/></a></h1>
            <p class="navButton topHeader__navButton" ref="navButton"><a class="navButton__a" href="#" @click="toggleMenu()">Menu</a></p>
          </div>
        </div>
      </div>
    </header>
    <nav class="nav" ref="navBody">
      <div class="customContainer">
        <ul class="nav__ul">
          <li class="nav__li01"><span class="nav__title">{{ word_chg('予約する') }}</span>
            <ul class="nav__ul nav__ul--nested">
              <li class="nav__li nav__li--nested"><a href="#" @click="routerLinkAction('/reservation/drive')" class="nav__a nav__a--nested" >
                {{ word_chg('走行予約') }}</a></li>
              <li class="nav__li nav__li--nested"><a href="#" @click="routerLinkAction('/reservation/lodging')" class="nav__a nav__a--nested" >{{ word_chg('宿泊予約') }}</a></li>
              <li class="nav__li nav__li--nested"><a href="#" @click="routerLinkAction('/reservation/facility')" class="nav__a nav__a--nested" >{{ word_chg('施設予約') }}</a></li>
            </ul>
          </li>
          <li class="nav__li"><a href="#" @click="routerLinkAction('/reserved/drive')" class="nav__a" >{{ word_chg('予約確認') }}</a></li>
          <li class="nav__li"><a href="#" @click="routerLinkAction('/history/drive')" class="nav__a" >{{ word_chg('利用履歴') }}</a></li>
          <li class="nav__li"><a href="#" @click="routerLinkAction('/information/list')" class="nav__a" >{{ word_chg('お知らせ') }}</a></li>
          <li class="nav__li"><a href="#" @click="routerLinkAction('/user/index')" class="nav__a" >{{ word_chg('会員証') }}</a></li>
          <li class="nav__li"><a href="#" @click="routerLinkAction('/logout')" class="nav__a" >{{ word_chg('ログアウトmenu') }}</a></li>
          <!-- <li class="nav__li"><a href="#" @click="" class="nav__a" >ログアウト</a></li> -->
        </ul>
      </div>
    </nav>
    <div class="container-fluid " data-bs-theme="">
      
      <div class="row row-eq-height">
        <router-view :display-class="mainDisplayClass"></router-view>
      </div>
    </div>
    <BsFooterView></BsFooterView>
  </div>
</template>
<style scoped>
  .nav--open {
    z-index: 30 !important;
  }
  .backButton {
    width: 3.0757689422rem;
    height: 2.7756939235rem;
  }
  .topHeader__backButton {
    position: absolute;
    top: 40%;
    left: 0;
  }
  .backButton__a {
    cursor: pointer;
  }
  .row-eq-height {
    display: flex;
    flex-wrap: wrap;
  }
  .table tbody tr td {
    vertical-align: middle !important;
  }
</style>
<style>
  .table tbody tr td {
    vertical-align: middle !important;
  }
</style>
<script>

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../../assets/main/main.css';

// import Vue from 'vue'
// import BsHeaderView from '../organisms/BsHeaderView.vue'
// import BsNavMenuView from '../organisms/BsNavMenuView.vue'
import BsFooterView from '../organisms/BsFooterView.vue'
import { mapState } from 'vuex'
export default {
  name: 'home',
  data: function(){
      return {
          test: 'tetestte',
          menuDisplay: true,
        //   count: this.$store.state.count
      }
  },
  computed:{
    ...mapState(['count']),
    mainDisplayClass() {
      if(this.menuDisplay){
        return 'col-md-12 ms-sm-auto col-lg-12 px-md-4';
      }else{
        return 'col-md-12 ms-sm-auto col-lg-12 px-md-4';
      }
    },
    nonTopPage(){
      if(
        this.$route.path == '/'
      ){
        return false;
      }
      return true;
    },
    backBtnDisp(){
      if(
        this.$route.path != ''
      ){
        return true;
      }
      return false;
    },
    pageHeaderTitle(){
      if(
        this.$route.path.startsWith('/reservation/')
      ){
        return 'RESERVATION'
      }
      else if(
        this.$route.path.startsWith('/reserved/')
      ){
        return 'RESERVED'
      }
      else if(
        this.$route.path.startsWith('/history/')
      ){
        return 'HISTORY'
      }
      else if(
        this.$route.path.startsWith('/event/')
      ){
        return 'EVENT'
      }
      else if(
        this.$route.path.startsWith('/information/')
      ){
        return 'INFORMATION'
      }
      else if(
        this.$route.path.startsWith('/user/')
      ){
        return 'MEMBER'
      }
      else if(
        this.$route.path.startsWith('/inquiry/')
      ){
        return 'INQUIRY'
      }
      else if(
        this.$route.path.startsWith('/files/')
      ){
        return 'FILE'
      }
      return '';
    }
  },
  components: {
    // BsHeaderView,
    // BsNavMenuView,
    BsFooterView,
  },
  async created () {
    if(
        this.$store.state.auth.token == null || this.$store.state.auth.token == "null" || this.$store.state.auth.token == undefined || this.$store.state.auth.token == 'undefined'
      ){
        const ls_token = localStorage.getItem('token');
        if(typeof ls_token === 'string' && ls_token.length > 0){
          console.log('App ls_token login', ls_token);
        }else{
          if(
            this.$router.path != '/privacy'
          ){
            this.$router.push({ path: '/logout' });
          }
        }
      }
      else if(
        (
        this.$store.state.auth.userId == null || this.$store.state.auth.userId == 'null'
          || this.$store.state.auth.userId == false || this.$store.state.auth.userId == 'false'
          || this.$store.state.auth.userId == undefined || this.$store.state.auth.userId == 'undefined'
        ) && (this.$store.state.auth.token != null && this.$store.state.auth.token != "null" && this.$store.state.auth.token != undefined && this.$store.state.auth.token != 'undefined' && this.$store.state.auth.token != '')
      ){
        console.log('app created login tokenだけ', this.$store.state.auth.token);
      }

    console.log('check page created!!!');
    this.loadUser();
      // this.sel_month = this.month_list[12].key;
  },
  methods:{
    backAction(){
      this.$router.go(-1);
    },
    toggleMenu(){
      this.$refs.navButton.classList.toggle('navButton--open');
      this.$refs.navBody.classList.toggle('nav--open');
    },
    routerLinkAction(to_path){
      if(this.$refs.navBody.classList.contains('nav--open')){
        this.toggleMenu();
      }
      this.$router.push({ path: to_path })
    },
    loadUser(){
      console.log('loadUser');
      const params = {};
      params['id'] = this.$store.state.auth.userId;
      console.log('params', params);
      return this.$store.dispatch('fetchBasicLists', {data: params, target: 'user', targetF: 'get'})
      .catch((err) => {
        console.log('loadUser did not load', err);
        // alert('err' + err);
        this.$router.push({ path: '/logout' })
      })
      .then(() => {})
      .finally(() => {});
    },
  },
}
</script>

<style scoped>
    /* @import "../../assets/bootstrap/css/dashboard.css"; */
</style>
